import React, { useEffect, useState } from 'react'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import { Link, useParams } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import useOrderStore from '../stores/orderStore'
import { orderStatus } from '../utils/constants'
import useToastStore from '../stores/toastStore'
import { formatPrice } from '../utils/format'


const TransactionDetail = () => {
    const { order, fetchOrder, updateOrder, clearState } = useOrderStore()
    const { id } = useParams()
    const [showModal, setShowModal] = useState(false)
    const { addToast } = useToastStore()

    useEffect(() => {
        fetchOrder(id)
    }, [fetchOrder, id])

    const [dataHistory] = useState([
        {
            name: 'Admin',
            time: '2 hours ago',
            action: 'Delivery Item',
        },
        {
            name: 'You',
            time: '4 hours ago',
            action: 'Paid',
        },
        {
            name: 'Admin',
            time: '6 hours ago',
            action: 'Confirmed',
        },
        {
            name: 'You',
            time: '8 hours ago',
            action: 'Place Offer',
        },
    ])

    const handlePaidClick = () => {
        setShowModal(true)
    }

    const handleClose = () => {
        setShowModal(false)
    }

    const handleConfirm = async () => {
        const updateParams = {
            status: 'paid',
        }

        const result = await updateOrder(order.id, { order: updateParams })

        if (result.success) {
            addToast('Update thành công!', 'success')
        } else {
            addToast(result.message, 'danger')
        }

        clearState()
        handleClose()
    }

    if (!order) return <></>

    return (
        <div className="item-details">
            <Header />
            <div className="tf-section tf-item-details style-2">
                <div className="themesflat-container">
                    <div className="row">
                        <div className="col-xl-6 col-md-12">
                            <div className="content-left">
                                {order.order_items.map((orderItem) => {
                                    const { item } = orderItem
                                    return (
                                        <div key={item.id} className="sc-card-activity style1">
                                            <div className="content">
                                                <div className="media">
                                                    <img src={item.images[0]?.url} alt={item.name} />
                                                </div>
                                                <div className="infor">
                                                    <h5>{item.name}</h5>
                                                    <div className="time">
                                                        <span>{`${item.float_num || ''} ${item.phase || ''}`}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="price">
                                                <h5>Giá {formatPrice(item.price)} vnđ</h5>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-12">
                            <div className="content-right">
                                <div className="sc-item-details">
                                    <div className="meta-item">
                                        <div className="left">
                                            <h2>Đơn hàng #{order.id}</h2>
                                        </div>
                                    </div>
                                    <div className="meta-item-details">
                                        <div className="item-style-2">
                                            <div className="item meta-price">
                                                <span className="heading">Thành tiền</span>
                                                <div className="price">
                                                    <div className="price-box">
                                                        <h5>{formatPrice(order.total_price)} vnđ</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item-style-2">
                                            <div className="item meta-price">
                                                <span className="heading">Status</span>
                                                <div className="price">
                                                    <div className="price-box">
                                                        <h5>{orderStatus[order.status]?.name || 'Unknown'}</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Link
                                        to="#"
                                        className="sc-button loadmore style bag fl-button pri-3"
                                        onClick={handlePaidClick}
                                    >
                                        <span>Paid</span>
                                    </Link>
                                    {/*<div className="flat-tabs themesflat-tabs">
                                        <Tabs>
                                            <TabList>
                                                <Tab>History</Tab>
                                            </TabList>

                                            <TabPanel>
                                                <ul className="bid-history-list">
                                                    {dataHistory.map((item, index) => (
                                                        <li key={index}>
                                                            <div className="content">
                                                                <div className="client">
                                                                    <div className="sc-author-box style-2">
                                                                        <div className="author-infor">
                                                                            <div className="name">
                                                                                <h6>{item.name}</h6>{' '}
                                                                                <span>{item.action}</span>
                                                                            </div>
                                                                            <span className="time">{item.time}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </TabPanel>
                                        </Tabs>
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton></Modal.Header>
                <div className="modal-body space-y-20 pd-40">
                    <h3>Mua vật phẩm</h3>
                    <p className="text-center">
                        <span className="price color-popup">
                            Bạn có chắc chắn muốn đánh dấu đơn hàng này là đã thanh toán không?
                        </span>
                    </p>
                    <button className="btn btn-primary" onClick={handleConfirm}>
                        Xác nhận
                    </button>
                    <button className="btn btn-cancel" onClick={handleClose}>
                        Huỷ
                    </button>
                </div>
            </Modal>
        </div>
    )
}

export default TransactionDetail
